import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { RoleGuard } from './core/guard/role.guard';
import { RoleEnum } from '@xfeet-workspace/xfeet-entities/enums';


const routes: Routes = [
  { path:'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  { path:'public-counter', loadChildren: () => import('./views/pages/public-counter/public-counter.module').then(m => m.PublicCounterModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'company',
        data: {roles: [RoleEnum.GESTION_DISTRIBUTEUR, RoleEnum.GESTION_ACTIVITE_SOCIETE]},
        canActivate: [RoleGuard],
        loadChildren: () => import('./views/pages/company/company.module').then(m => m.CompanyModule)
      },
      {
        path: 'member',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.SUPPORT, RoleEnum.COMMERCIAL]},
        loadChildren: () => import('./views/pages/member/member.module').then(m => m.MemberModule),
      },
      {
        path: 'orders',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.LOGISTIC_COMMANDE]},
        loadChildren: () => import('./views/pages/orders/orders.module').then(m => m.OrdersModule),
      },
      {
        path: 'recovering',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.LOGISTIC_RECOUVREMENT]},
        loadChildren: () => import('./views/pages/recovering/recovering.module').then(m => m.RecoveringModule),
      },
      {
        path: 'eva-foam',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.LOGISTIC_FRAISAGE]},
        loadChildren: () => import('./views/pages/eva-foam/eva-foam.module').then(m => m.EvaFoamModule),
      },
      {
        path: 'thermoforming',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.LOGISTIC_RECOUVREMENT]},
        loadChildren: () => import('./views/pages/thermoforming/thermoforming.module').then(m => m.ThermoformingModule),
      },
      {
        path: 'comptability',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.COMMERCIAL, RoleEnum.LOGISTIC_FABRICATION]},
        loadChildren: () => import('./views/pages/comptability/comptability.module').then(m => m.ComptabilityModule),
      },
      {
        path: 'reporting',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.GESTION_COMMERCIALE, RoleEnum.COMMERCIAL, RoleEnum.SUPPORT]},
        loadChildren: () => import('./views/pages/reporting/reporting.module').then(m => m.ReportingModule)
      },
      {
        path: 'job',
        canActivate: [RoleGuard],
        data: {roles: [RoleEnum.SUPPORT]},
        loadChildren: () => import('./views/pages/job/job.module').then(m => m.JobModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'ui-components',
        loadChildren: () => import('./views/pages/ui-components/ui-components.module').then(m => m.UiComponentsModule)
      },
      {
        path: 'advanced-ui',
        loadChildren: () => import('./views/pages/advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule)
      },
      {
        path: 'form-elements',
        loadChildren: () => import('./views/pages/form-elements/form-elements.module').then(m => m.FormElementsModule)
      },
      {
        path: 'tables',
        loadChildren: () => import('./views/pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/pages/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'general',
        loadChildren: () => import('./views/pages/general/general.module').then(m => m.GeneralModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      // { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking', anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
